import { Button } from 'src/components/atoms';
import { calcSpacing } from 'src/components/foundations';
import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const SectionContainer = styled.div`
  margin-bottom: ${calcSpacing(2.5)}px;
  width: 100%;
`;

export const QuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const SectionHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 204px;
`;

export const QuestionsSectionTitle = styled.h2`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH4)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0;
  letter-spacing: 0.2px;
`;

export const QuestionsSectionSubtitle = styled.p`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.2px;
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0;
`;

export const AddQuestionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 4px 0;
  flex-shrink: 0;
`;

export const AddQuestionButton = styled(Button)`
  && {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: auto;
    min-width: unset;
    height: 40px;
    padding: 8px 16px;
    background-color: transparent;
    border: 1px solid #282e37;
    border-radius: 12px;
    color: #282e37;
    white-space: nowrap;
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.emphasis)};
    font-weight: 600;
    letter-spacing: 0.2px;
  }

  @media (hover: hover) {
    &:hover:not(:disabled) {
      background-color: ${(props) =>
        props.theme.atlas.semantic.color.action.secondary.hoverFill};
    }
  }
`;

export const AddQuestionBottomWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const AddQuestionButtonBottom = styled(Button)<{
  variant?: 'primary' | 'secondary' | 'tertiary' | 'error';
}>`
  && {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: auto;
    min-width: unset;
    height: 40px;
    padding: 8px 12px;
    background-color: ${(props) =>
      props.variant === 'tertiary'
        ? 'transparent'
        : props.theme.atlas.core.color.gray[900]};
    border: none;
    border-radius: 8px;
    color: ${(props) =>
      props.variant === 'tertiary'
        ? props.theme.atlas.semantic.color.type.default
        : props.theme.atlas.semantic.color.surface.default};
    ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.emphasis)};
    font-weight: 400;
    letter-spacing: 0.2px;
  }

  @media (hover: hover) {
    &:hover:not(:disabled) {
      background-color: ${(props) =>
        props.variant === 'tertiary'
          ? 'transparent'
          : props.theme.atlas.core.color.gray[800]};
      font-weight: ${(props) => (props.variant === 'tertiary' ? '600' : '400')};
    }
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  background: transparent;
`;

export const EmptyStateIllustration = styled.img`
  width: 160px;
  height: 132px;
  object-fit: contain;
  display: block;
`;

export const EmptyStateLower = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: ${calcSpacing(2.8)}px;
  gap: ${calcSpacing(3)}px;
`;

export const EmptyStateCopy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${calcSpacing(1)}px;
  width: 100%;
  text-align: center;
`;

export const EmptyStateTitle = styled.p`
  margin: 0;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.headingH3)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const EmptyStateDescription = styled.p`
  margin: 0;
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
`;

export const LoadingStateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${calcSpacing(10)}px ${calcSpacing(2.5)}px;
  width: 100%;
`;

export const MinimalCardContent = styled.div`
  padding: ${calcSpacing(2)}px;
`;

export const QuestionsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
